import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogrishneshwar() {



    const cardData = {

keyword: "Mumbai to Grishneshwar Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Grishneshwar Cab services for pilgrimage travel, Jyotirlinga darshan, family tours, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra routes, we ensure a smooth, comfortable, and hassle-free spiritual journey to Grishneshwar Jyotirlinga near Ellora.",

topPlaces: [
    {
        title: "Grishneshwar Jyotirlinga Temple",
        description:
            "Grishneshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva located near Ellora Caves. It is a highly revered pilgrimage site visited by devotees from across India."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are a UNESCO World Heritage Site known for magnificent rock-cut temples and monuments representing Hindu, Buddhist, and Jain heritage."
    },
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are famous for ancient Buddhist paintings, sculptures, and rock-cut architecture showcasing India’s rich historical and artistic heritage."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is a powerful medieval fortress known for its strategic design, strong defenses, and panoramic views from the top."
    },
    {
        title: "Aurangabad City",
        description:
            "Aurangabad is a historic city near Grishneshwar known for its cultural heritage, monuments, and as a gateway to Ajanta and Ellora caves."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is often called the Mini Taj Mahal, known for its Mughal architecture and historical significance in Aurangabad."
    },
    {
        title: "Verul (Ellora Village)",
        description:
            "Verul is the village near Ellora caves offering local culture, small temples, and access points for visiting the cave complex."
    },
    {
        title: "Shivaji Maharaj Fort Routes",
        description:
            "The route from Mumbai to Grishneshwar passes through historically significant regions connected to Maratha heritage and forts."
    },
    {
        title: "Khuldabad",
        description:
            "Khuldabad is a nearby town known for Sufi shrines and historical tombs, adding cultural value to the pilgrimage circuit."
    },
    {
        title: "Ellora Kailasa Temple",
        description:
            "The Kailasa Temple at Ellora is a masterpiece rock-cut structure dedicated to Lord Shiva and one of the largest monolithic temples in the world."
    }
],



services: [
{
name: "Mumbai to Grishneshwar Cab",
description: "Mumbai Airport Cab offers Mumbai to Grishneshwar Cab service for safe, comfortable, and reliable pilgrimage travel to the famous Grishneshwar Jyotirlinga temple near Ellora in Maharashtra. Whether you are travelling for darshan, family pilgrimage, religious tour, or weekend spiritual visit, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury options. Our professional chauffeurs are experienced in long highway and temple routes, ensuring smooth driving, timely pickup, passenger safety, and a stress-free journey. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your spiritual journey comfortable and peaceful."
},
{
name: "Mumbai to Grishneshwar Taxi",
description: "Mumbai to Grishneshwar Taxi service by Mumbai Airport Cab provides dependable intercity pilgrimage transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families and groups visiting Grishneshwar Jyotirlinga, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai."
},
{
name: "Mumbai to Grishneshwar Cab Fare",
description: "Mumbai to Grishneshwar Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective pilgrimage travel with comfort and reliability."
},
{
name: "Mumbai to Grishneshwar Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Grishneshwar Car Rental service with chauffeur-driven vehicles for long-distance temple travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family and group pilgrimage. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Grishneshwar One Way Cab",
description: "Mumbai to Grishneshwar One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for pilgrimage, family visits, and intercity travel."
},
{
name: "Mumbai to Grishneshwar Outstation Cab",
description: "Mumbai to Grishneshwar Outstation Cab service offers reliable long-distance travel with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free temple journeys."
},
{
name: "Mumbai to Grishneshwar Temple Cab",
description: "Mumbai to Grishneshwar Temple Cab service provides dedicated transportation for devotees visiting the Grishneshwar Jyotirlinga temple. Mumbai Airport Cab ensures safe travel, smooth highway driving, and comfortable vehicles for families and pilgrims seeking a peaceful darshan experience."
},
{
name: "Mumbai to Grishneshwar Jyotirlinga Cab",
description: "Mumbai to Grishneshwar Jyotirlinga Cab service is specially designed for devotees undertaking spiritual journeys to one of the twelve Jyotirlingas. Mumbai Airport Cab ensures experienced drivers, flexible schedules, and comfortable vehicles for a smooth and divine travel experience."
},
{
name: "Mumbai to Grishneshwar Pilgrimage Cab",
description: "Mumbai to Grishneshwar Pilgrimage Cab service is designed for devotees visiting sacred temples and spiritual sites. Mumbai Airport Cab provides comfortable vehicles, experienced drivers, and safe highway travel for a meaningful pilgrimage experience."
},
{
name: "Mumbai to Grishneshwar Family Cab",
description: "Mumbai to Grishneshwar Family Cab service provides safe and comfortable transportation for families travelling together for pilgrimage. Mumbai Airport Cab ensures spacious vehicles, experienced drivers, luggage-friendly travel, and flexible booking options for a stress-free journey."
},
{
name: "Mumbai to Grishneshwar Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Grishneshwar Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long temple journeys."
},
{
name: "Mumbai to Grishneshwar SUV Cab",
description: "Mumbai to Grishneshwar SUV Cab service provides powerful and comfortable vehicles suitable for highway and temple route travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups."
},
{
name: "Mumbai to Grishneshwar Round Trip Cab",
description: "Mumbai to Grishneshwar Round Trip Cab service offers complete return journey solutions for same-day or multi-day temple visits. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Grishneshwar Travel Service",
description: "Mumbai to Grishneshwar Travel Service provides complete transportation solutions for pilgrims and families visiting the Jyotirlinga temple. Mumbai Airport Cab ensures safe, comfortable, and well-organized travel with professional drivers and flexible itineraries."
},
{
name: "Mumbai to Grishneshwar Religious Tour Cab",
description: "Mumbai to Grishneshwar Religious Tour Cab service offers organized spiritual travel for devotees. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and safe highway travel for a meaningful pilgrimage experience."
},
{
name: "Mumbai to Grishneshwar Highway Cab",
description: "Mumbai to Grishneshwar Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides professional chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Grishneshwar Budget Cab",
description: "Mumbai to Grishneshwar Budget Cab service offers economical travel options for pilgrimage without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective journeys."
},
{
name: "Mumbai to Grishneshwar Express Cab",
description: "Mumbai to Grishneshwar Express Cab service provides fast and efficient transportation for urgent temple visits. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely and smooth travel."
},
{
name: "Mumbai to Grishneshwar Night Travel Cab",
description: "Mumbai to Grishneshwar Night Travel Cab service provides safe overnight transportation for pilgrims. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
}
],

tableData: [
["Mumbai to Grishneshwar Cab","Mumbai to Grishneshwar Taxi"],
["Mumbai to Grishneshwar Cab Fare","Mumbai to Grishneshwar Car Rental"],
["Mumbai to Grishneshwar One Way Cab","Mumbai to Grishneshwar Outstation Cab"],
["Mumbai to Grishneshwar Temple Cab","Mumbai to Grishneshwar Jyotirlinga Cab"],
["Mumbai to Grishneshwar Pilgrimage Cab","Mumbai to Grishneshwar Family Cab"],
["Mumbai to Grishneshwar Innova Cab","Mumbai to Grishneshwar SUV Cab"],
["Mumbai to Grishneshwar Round Trip Cab","Mumbai to Grishneshwar Travel Service"],
["Mumbai to Grishneshwar Religious Tour Cab","Mumbai to Grishneshwar Highway Cab"],
["Mumbai to Grishneshwar Budget Cab","Mumbai to Grishneshwar Express Cab"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Grishneshwar Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Grishneshwar Cab services for devotees, families, pilgrims, senior citizens, and religious travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Convenient Jyotirlinga Darshan Journey",
        WhyChoosedescription: "Travel comfortably to Grishneshwar Temple, one of the twelve sacred Jyotirlingas of Lord Shiva, located near Ellora Caves in Maharashtra."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Tours",
        WhyChoosedescription: "Our cab service is ideal for Grishneshwar Jyotirlinga Darshan, family pilgrimages, Shiva devotees, temple tours, and customized spiritual travel plans."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or complete Jyotirlinga pilgrimage package, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our professional chauffeurs are familiar with pilgrimage routes and ensure safe, comfortable, and stress-free transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Devotees, and Groups",
        WhyChoosedescription: "From individual devotees and families to religious groups and pilgrimage organizers, we provide suitable vehicles for every spiritual travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do devotees book Mumbai to Grishneshwar Cabs?",
        answer: "Grishneshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and attracts devotees from across India for darshan and spiritual blessings."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Grishneshwar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Grishneshwar travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available based on passenger count and comfort requirements."
    },
    {
        question: "Do you provide same-day return trips?",
        answer: "Yes, customers can choose same-day return journeys depending on their darshan schedule and travel requirements."
    },
    {
        question: "Can senior citizens travel comfortably on this route?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for elderly passengers, families, and long-distance religious travel."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for religious groups, family tours, and temple pilgrimage trips."
    },
    {
        question: "Can I visit Ellora Caves along with Grishneshwar Temple?",
        answer: "Yes, customers frequently combine Grishneshwar Jyotirlinga Darshan with Ellora Caves, Daulatabad Fort, and Aurangabad sightseeing."
    },
    {
        question: "Can pickup be arranged from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Grishneshwar visits?",
        answer: "Yes, advance booking is recommended, especially during Shravan month, Mahashivratri, Mondays, and festival seasons."
    },
    {
        question: "How can I book a Mumbai to Grishneshwar Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Shankar Kulkarni",
        feedback:
            "Our Grishneshwar Jyotirlinga pilgrimage was organized perfectly. The cab was comfortable, the driver was courteous, and we also visited Ellora Caves during the trip.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaidehi Deshpande",
        feedback:
            "Mumbai Airport Cabs provided excellent service for our family pilgrimage. The vehicle was clean, spacious, and the journey to Grishneshwar Temple was smooth and stress-free.",
        rating: 5
    }
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Grishneshwar Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-grishneshwar-cab.jpg",
"description": "Book Mumbai to Grishneshwar cab service for pilgrimage and temple travel near Ellora. Mumbai Airport Cabs offers safe and comfortable outstation taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability for spiritual journeys.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-grishneshwar-cab"
}
};








    return (
        <div>


<Helmet>
  <title>Mumbai to Grishneshwar Cab | Temple Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Grishneshwar cab for pilgrimage travel near Ellora. Safe and comfortable temple taxi service with professional drivers and 24x7 outstation availability."
/>

<meta
 name="keywords"
 content="mumbai to grishneshwar cab, mumbai to grishneshwar taxi, mumbai to grishneshwar cab fare, mumbai to grishneshwar car rental, mumbai to grishneshwar one way cab, mumbai to grishneshwar outstation cab, mumbai to grishneshwar temple cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogrishneshwar;